import {
  fetchBreakDownSummary,
  fetchDayWiseBreakDown,
  fetchNavigationData,
} from "../../services/breakDownService";
import {
  breakDownCollectionSummaryFetched,
  dayWiseBreakDownCollectionFetched,
  navigationDataFetched,
  dayWiseBreakDownViewFetched,
} from "../actions/dayWiseBreakDownAction";
import { createAllActionCreators } from "./actionCreatorUtil";

export const dayWiseBreakDownViewAction = (params) => (dispatch) => {
  dispatch(dayWiseBreakDownViewFetched(params));
};

const dayWiseBreakDownActionCreators = {
  dayWiseBreakDownCollectionListAction: {
    service: fetchDayWiseBreakDown,
    action: dayWiseBreakDownCollectionFetched,
  },
  navigationDataAction: {
    service: fetchNavigationData,
    action: navigationDataFetched,
  },
  breakDownCollectionSummaryAction: {
    service: fetchBreakDownSummary,
    action: breakDownCollectionSummaryFetched,
  },
};

export const {
  dayWiseBreakDownCollectionListAction,
  navigationDataAction,
  breakDownCollectionSummaryAction,
} = createAllActionCreators(dayWiseBreakDownActionCreators);
